import { useEffect, useMemo, useState } from "react";
import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";
import Formulario from "../../Componentes/Utils/Formulario";
import FormComp from "../../Componentes/FormComp";
import useApi from "../../hooks/useApi";

export default function ModalNovoEquipamento({ onClose, onCreated, tiposAtivo, equipamento }) {
  const api = useApi();
  const isEdit = Boolean(equipamento?.id);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState(() => {
    if (equipamento) {
      const raw = equipamento._raw ?? {};
      const idTipo =
        raw.id_tipo_ativo != null
          ? String(raw.id_tipo_ativo)
          : equipamento.id_tipo_ativo != null
          ? String(equipamento.id_tipo_ativo)
          : "";
      return {
        id_tipo_ativo: idTipo,
        descricao: equipamento.descricao && equipamento.descricao !== "—" ? equipamento.descricao : "",
        patrimonio: equipamento.patrimonio && equipamento.patrimonio !== "—" ? equipamento.patrimonio : "",
        serial: equipamento.serial && equipamento.serial !== "—" ? equipamento.serial : "",
        observacoes: raw.observacoes ?? equipamento.observacoes ?? "",
      };
    }
    return {
      id_tipo_ativo: "",
      descricao: "",
      patrimonio: "",
      serial: "",
      observacoes: "",
    };
  });

  useEffect(() => {
    if (!isEdit) return;
    if (!form.id_tipo_ativo && Array.isArray(tiposAtivo) && tiposAtivo.length && equipamento?.tipo) {
      const match = tiposAtivo.find(
        (t) => String(t.descricao).trim().toUpperCase() === String(equipamento.tipo).trim().toUpperCase()
      );
      if (match) {
        setForm((prev) => ({ ...prev, id_tipo_ativo: String(match.id) }));
      }
    }
  }, [isEdit, tiposAtivo, equipamento, form.id_tipo_ativo]);

  const canSubmit = useMemo(() => {
    return (
      Boolean(String(form.id_tipo_ativo || "").trim()) &&
      Boolean(form.descricao?.trim()) &&
      Boolean(form.patrimonio?.trim())
    );
  }, [form.descricao, form.id_tipo_ativo, form.patrimonio]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => {
      if (name === "id_tipo_ativo") {
        return { ...prev, id_tipo_ativo: value };
      }
      if (name === "observacoes") {
        return { ...prev, observacoes: value };
      }
      return { ...prev, [name]: value.toUpperCase() };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;

    try {
      setSaving(true);

      const payload = {
        id_tipo_ativo: Number(form.id_tipo_ativo),
        descricao: form.descricao.trim().toUpperCase(),
        patrimonio: form.patrimonio.trim().toUpperCase(),
        num_serie: form.serial?.trim()?.toUpperCase() || null,
        observacoes: form.observacoes?.trim() || null,
      };

      if (isEdit) {
        await api.post("/Painel/API/InventarioTI/EditarAtivo/", {
          id_ativo: Number(equipamento.id),
          ...payload,
        });
      } else {
        await api.post("/Painel/API/InventarioTI/CreateAtivo/", payload);
      }

      onClose?.();
      onCreated?.();
    } catch (err) {
      console.error(err);
      alert(
        err?.response?.data?.message ||
          (isEdit ? "Erro ao atualizar equipamento." : "Erro ao cadastrar equipamento.")
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <Overlay state={true}>
      <Modal header close={onClose} size="md">
        <Formulario onSubmit={handleSubmit}>
          <FormComp
            title="TIPO"
            type="select"
            options={(tiposAtivo ?? []).map((t) => ({ value: String(t.id), label: t.descricao }))}
            obj
            valor={String(form.id_tipo_ativo || "")}
            name="id_tipo_ativo"
            changeFunc={handleChange}
            required
          />
          <FormComp
            title="EQUIPAMENTO"
            type="text"
            placeholder="EX: DELL LATITUDE 5420"
            valor={form.descricao}
            name="descricao"
            changeFunc={handleChange}
            required
          />
          <FormComp
            title="PATRIMÔNIO"
            type="text"
            placeholder="EX: TI-10293"
            valor={form.patrimonio}
            name="patrimonio"
            changeFunc={handleChange}
            required
          />
          <FormComp
            title="SERIAL"
            type="text"
            placeholder="EX: SN-XXXXX"
            valor={form.serial}
            name="serial"
            changeFunc={handleChange}
          />
          <FormComp
            title="OBSERVAÇÕES"
            type="textarea"
            valor={form.observacoes}
            name="observacoes"
            changeFunc={handleChange}
          />

          <FormComp
            type="submit"
            valor={saving ? "SALVANDO..." : isEdit ? "ATUALIZAR" : "SALVAR"}
            disabled={saving || !canSubmit}
          />
        </Formulario>
      </Modal>
    </Overlay>
  );
}
